import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../Store";

const FileAClaimButton = () => {
  const { casesStore } = useStore();
  const link = casesStore.presentation?.claimLink;
  if (!link) return null;

  return (
    <div className="button button--ifgray radius--6 margin--top-20 p-if-assistance">
      <a href={link}>File a claim</a>
    </div>
  );
};

export default observer(FileAClaimButton);
